 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK4352 from '@/components/eBook4352'
 import EBOOK43521 from '@/components/eBook43521'
 import EBOOK43522 from '@/components/eBook43522'
 import EBOOK43523 from '@/components/eBook43523'
 import EBOOK43524 from '@/components/eBook43524'
 import EBOOK43525 from '@/components/eBook43525'
 import EBOOK43526 from '@/components/eBook43526'
 import EBOOK43527 from '@/components/eBook43527'
 import EBOOK43528 from '@/components/eBook43528'
 import EBOOK43529 from '@/components/eBook43529'
 import EBOOK435210 from '@/components/eBook435210'
 import EBOOK435211 from '@/components/eBook435211'
 import EBOOK435212 from '@/components/eBook435212'
 import EBOOK435213 from '@/components/eBook435213'
 import EBOOK435214 from '@/components/eBook435214'
 import EBOOK435215 from '@/components/eBook435215'
 import EBOOK435216 from '@/components/eBook435216'
 import EBOOK435217 from '@/components/eBook435217'
 import EBOOK435218 from '@/components/eBook435218'
 import EBOOK435219 from '@/components/eBook435219'
 import EBOOK435220 from '@/components/eBook435220'
 import EBOOK435221 from '@/components/eBook435221'
 import EBOOK435222 from '@/components/eBook435222'
 import EBOOK435223 from '@/components/eBook435223'
 import EBOOK435224 from '@/components/eBook435224'
 import EBOOK435225 from '@/components/eBook435225'
 import EBOOK435226 from '@/components/eBook435226'
 import EBOOK435227 from '@/components/eBook435227'
 import EBOOK435228 from '@/components/eBook435228'
 import EBOOK435229 from '@/components/eBook435229'
 import EBOOK435230 from '@/components/eBook435230'
 import EBOOK435231 from '@/components/eBook435231'
 import EBOOK435232 from '@/components/eBook435232'
 import EBOOK435233 from '@/components/eBook435233'
 import EBOOK435234 from '@/components/eBook435234'
 import EBOOK435235 from '@/components/eBook435235'
 import EBOOK435236 from '@/components/eBook435236'
 import EBOOK435237 from '@/components/eBook435237'
 import EBOOK435238 from '@/components/eBook435238'
 import EBOOK435239 from '@/components/eBook435239'
 import EBOOK435240 from '@/components/eBook435240'
 import CBSCBSTURN from '@/components/CBS/CBSturn'
 import CBSCBSCOVER from '@/components/CBS/CBScover'
 import CBSCBS from '@/components/CBS/CBS'
 import CBSCBS1 from '@/components/CBS/CBS1'
 import CBSCBS2 from '@/components/CBS/CBS2'
 import EBOOK435241 from '@/components/eBook435241'
 import LOVE_2 from '@/components/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/eBook4352",
 			"name" : "eBook4352",
 			"component" : EBOOK4352
 		},
 		{
 			"path" : "/eBook43521",
 			"name" : "eBook43521",
 			"component" : EBOOK43521
 		},
 		{
 			"path" : "/eBook43522",
 			"name" : "eBook43522",
 			"component" : EBOOK43522
 		},
 		{
 			"path" : "/eBook43523",
 			"name" : "eBook43523",
 			"component" : EBOOK43523
 		},
 		{
 			"path" : "/eBook43524",
 			"name" : "eBook43524",
 			"component" : EBOOK43524
 		},
 		{
 			"path" : "/eBook43525",
 			"name" : "eBook43525",
 			"component" : EBOOK43525
 		},
 		{
 			"path" : "/eBook43526",
 			"name" : "eBook43526",
 			"component" : EBOOK43526
 		},
 		{
 			"path" : "/eBook43527",
 			"name" : "eBook43527",
 			"component" : EBOOK43527
 		},
 		{
 			"path" : "/eBook43528",
 			"name" : "eBook43528",
 			"component" : EBOOK43528
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js